module.exports = __webpack_public_path__ + "static/haulotte-compact-12-340ddbc95d50ea33f34a754996dc951f.jpg";